import { Injectable , Injector} from '@angular/core';
 
import { Platform } from '@ionic/angular';
//import {SqlLiteDatabase} from './SqlLiteDatabase';
 
import {Chat} from "../../bayadic-shared-models/chat/Chat";
import {AbstractChatMessage} from "../../bayadic-shared-models/classes/message/abstract-chat-message";
import { ChatsDatabaseService } from '../chats-database-service/chats-database-service';
import { LoggerService } from '../../app/services/logger.service';
@Injectable()
export class SpaceRepetitionDatabaseManagerProvider extends ChatsDatabaseService {

  constructor(
     public injector : Injector,
     public platform : Platform,
     public logger: LoggerService
  ) {
     super(injector, logger);
    
  }
  setReview(chat: Chat, message : AbstractChatMessage){
      // this.updateMessageReview(chat,message);
  }

}
